import { NgModule } from '@angular/core';
import { NgxSpinnerComponent } from './ngx-spinner.component';

@NgModule({
  declarations: [NgxSpinnerComponent],
  imports: [
  ],
  exports: [NgxSpinnerComponent]
})
export class NgxSpinnerModule { }
